import { getCenter } from 'ol/extent'
import { getTransform, getPointResolution } from 'ol/proj'
import { getLength, getDistance } from 'ol/sphere'
import { LineString } from 'ol/geom'

class ImageOverlay {
  constructor(options) {
    this.map = options.map
    this.imageUrl = options.imageUrl
    this.geometry = options.geometry
    this.rotation = options.rotation
    this.id = options.id
    this.lengthToUse = options.lengthToUse

    this.unselectedZIndex = 1
    this.selectedZIndex = 2

    this.container = document.getElementById('background-images-container')
    this.element = this.createImageElement()
    this.container.appendChild(this.element)

    
    this.map.getView().on('change:resolution', () => {
      this.updatePosition()
    })
    this.loadImage()
  }

  loadImage() {
    const image = this.element.querySelector('image')
    const img = new Image()
    img.crossOrigin = 'anonymous'
    img.src = this.imageUrl

    img.onload = () => {
      image.setAttributeNS('http://www.w3.org/1999/xlink', 'href', this.imageUrl)
      this.setupPositioning()
    }

    img.onerror = () => {
      console.error('Erreur de chargement de l\'image')
    }
  }

  setupPositioning() {
    const updatePosition = () => {
      if (!this.geometry || !this.map.getView()) {
        requestAnimationFrame(updatePosition)
        return
      }

      try {
        this.updatePosition()
      } catch (e) {
        console.error('Erreur de positionnement:', e)
        requestAnimationFrame(updatePosition)
      }
    }

    this.map.on('postrender', updatePosition)
    updatePosition()
  }

  createImageElement() {
    this.remove()

    const wrapper = document.createElement('div')
    wrapper.id = this.id
    wrapper.style.position = 'absolute'
    wrapper.style.zIndex = this.unselectedZIndex

    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
    svg.setAttribute('width', '100%')
    svg.setAttribute('height', '100%')

    const image = document.createElementNS('http://www.w3.org/2000/svg', 'image')
    image.setAttribute('width', '100%')
    image.setAttribute('height', '100%')
    image.setAttribute('preserveAspectRatio', 'xMidYMid meet')

    svg.appendChild(image)
    wrapper.appendChild(svg)
    return wrapper
  }

  updatePosition() {
    if (!this.geometry) return

    const size = this.calculateSize()

    const extent = this.geometry.getExtent()
    const center = getCenter(extent)
    const pixelCenter = this.map.getPixelFromCoordinate(center)
    const rot = this.rotation * -1

    const svg = this.element.querySelector('svg')
    svg.setAttribute('width', `${size}px`)
    svg.setAttribute('height', `${size}px`)
    
    svg.style.transformOrigin = 'center center'
    svg.style.transform = `
      translate(${pixelCenter[0]}px, ${pixelCenter[1]}px)
      translate(-50%, -50%)
      rotate(${rot}deg)
    `
  }

  calculateSize() {
    const view = this.map.getView()
    const resolution = view.getResolution()
    const center = view.getCenter()
    const projection = view.getProjection()

    const trueResolution = getPointResolution(projection, resolution, center)

    return this.lengthToUse / trueResolution
  }

  updateGeometry(newGeometry, newRotation) {
    this.geometry = newGeometry
    this.rotation = newRotation
    this.updatePosition()
  }

  select() {
    this.element.style.zIndex = this.selectedZIndex
  }

  unselect() {
    this.element.style.zIndex = this.unselectedZIndex
  }

  remove() {
    const divExists = document.getElementById(this.id)
    if (divExists) this.container.removeChild(divExists)
  }
}

export default ImageOverlay